'use strict';

import angular from 'angular';
import Quantity from './quantity.controller';

export default angular.module('bfastCaptureManagerApp.application.quantity', [])
  .controller('AppQuantityController', Quantity)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/quantity/index.js